<template>

  <div class="content">
    <div class="container-fluid">
      <card>
        <b-alert show variant="danger" dismissible v-if="errors.length">
          <h4 class="alert-heading my-0 text-center"><i class="fas fa-exclamation-triangle"></i> Hata</h4>
          <ul class="mb-0">
            <li v-for="e in errors">
              <b>{{e}}</b> Alanını Doldurmanız Gerek
            </li>
          </ul>
        </b-alert>


        <div class="row">
          <div class="col-12 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" v-bind:class="{'is-invalid' : errors.includes('Başlık')}" id="basic-addon1">Başlık</span>
            </div>
            <input type="text" class="form-control" placeholder="Başlık" aria-label="Başlık" v-bind:class="{'is-invalid' : errors.includes('Başlık')}" v-model="email.subject" id="name" aria-describedby="basic-addon1">
          </div>
          <div class="col-12 input-group mb-3">
            <tinymce id="d1" v-model="email.body" v-bind:class="{'is-invalid' : errors.includes('İçerik')}" style="width: 100%" :other_options="options"></tinymce>
          </div>
          <div class="col-12 mb-3 d-flex justify-content-end align-items-start">
            <button class="btn btn-primary btn-fill float-md-right" v-on:click="checkForm">Kaydet</button>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
  export default {
    data: function () {
      return {
        email:{
          subject:null,
          body: null
        },
        errors:[],
        // end of post data
        options: {
          language_url: '/static/plugins/tinymce-lang/tr.js',
          height: 300
        }
      }
    },
    components: {
      Checkbox,
      Card
    },
    methods: {
      checkForm:function() {
        this.errors = [];
        if(!this.email.subject) {this.errors.push("Başlık")};
        if(!this.email.body) {this.errors.push("Başlık")};
        if(!this.errors.length) {
          this.sendBulkEmail()
        }
      },
      sendBulkEmail: function() {
        this.notifier('top', 'right', 'info', 'Toplu E-Posta Gönderimi Başladı. Lütfen bittiğini gösteren bildirimi almadan sayfayı kapatmayın.')
        this.$router.push('/newsletter')
        this.$http.post('/api/newsletter/send-bulk-email', this.email).then(
          response => {
            this.notifier('top', 'right', 'success', 'Toplu E-Posta Gönderimi Başarılı')
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Toplu E-Posta Gönderimi Başarısız Oldu. Problem Devam Ederse Destek Ekibine Başvurun.')
          })
      }
    }
  }
</script>
<style>
.input-group-text.is-valid{
  border-color: #28a745 !important;
}
.input-group-text{
  transition: 300ms;
}
.input-group-text.is-invalid{
  border-color: #dc3545 !important;
  background-color: #dc3545;
  color:#fff;
}
.form-check-label{
  font-size: 16px !important;
  line-height: 15px !important;
  text-transform: capitalize !important;
}
.seo-text{
  background-color: #e9ecef;
  border: 1px solid #ced4da; 
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/NewsletterModules/SendBulk.vue